import React from 'react'
import {PropTypes} from 'prop-types'

// import history from '../../history';  // Examplo of tag property: onClick={e => { history.goBack() }}

// Bottom to back to de previous page.
export const ButtonBack = (props) => {

    return (
        
        // <i className="material-icons snx-icon-back mx-3"  onClick={e => { history.goBack() }}>arrow_back</i>
        <i className="material-icons snx-icon-back md-18"  
            {...props}
        >arrow_back</i>
        
    )
}

ButtonBack.contextTypes = {
    t: PropTypes.func
}

